export type LayoutType = "bare" | "fullheight" | "standard";
